import FormValidation from "../../Validation/FormValidation";
import {gsap} from "gsap";

const FormRating = {
    count: 5,
    rating: null,
    iconPath: 'modules/forms/Inputs/Rating/img',

    init(form) {
        this.el = form.find('.input.rating');
        if (!this.el) return;
        this.input = this.el.find('input[name="rating"]');
        this.imageInput = this.el.find('input[name="rating_img"]');
        this.prepare();
        this.bindInput();
    },

    bind(form) {
        this.input = 'input[name="rating"]';
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });
    },

    prepare() {
        const holder = $('<div class="holder"></div>').appendTo(this.el);

        const star = $('<div class="star">' +
            '<img class="blank" src="/'+ this.iconPath + '/icon.star.outine.svg" alt="">' +
            '<img class="filled" src="/'+ this.iconPath + '/icon.star.svg" alt="">' +
            '</div>'
        )

        for (let i = 1; i <= this.count; i++) {
            star.clone().attr('rating', i).appendTo(holder);
        }

        this.stars = this.el.find('.star');
    },

    bindInput() {
        this.stars.mouseenter((evt) => {
            this.slide($(evt.currentTarget));
        });

        this.stars.click((evt) => {
            this.set($(evt.currentTarget));
        });

        this.el.mouseleave((evt) => {
            this.resetTo(this.rating);
        })
    },

    slide(el) {
        el.siblings('.star').removeClass('active');
        el.addClass('active');
        el.prevAll('.star').addClass('active');
    },

    set(el) {
        this.rating = el.attr('rating');
        this.input.val(this.rating).trigger('change');
        this.imageInput.val(WEB_ROOT + '/' + this.iconPath + '/stars' + this.rating + '.png');
        gsap.timeline()
            .to(el, {scale: 1.4, ease: "expo.in", duration: 0.3})
            .to(el, {scale: 1, ease: "elastic.out(1,0.3)", duration: 1})
    },

    resetTo(nmb) {
        if (!nmb) {
            this.stars.removeClass('active');
            return;
        }
        this.rating = nmb;
        this.input.val(nmb);
        this.slide(this.stars.filter('[rating="' + nmb + '"]'));
    },

    reset(form) {
        this.rating=null;
        const el = form.find('.input.rating');
        el.find('[name="rating"]').val(null);
        el.find('[name="rating_img"]').val(null);
        el.find('.star').removeClass('active');
    },

    check(form) {
        let ok = true;
        this.input.each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el), this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');

        if (isRequired) return parseInt(input.val()) > 0
        else return true;

    },
}
export default FormRating;
